var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.901 22.8H12.099V12.495C12.1 5.606 17.44 0 24 0c6.562 0 11.901 5.606 11.901 12.496V22.8Zm-19.802-4.2h15.803v-6.104c0-4.575-3.544-8.296-7.9-8.296-4.358 0-7.902 3.721-7.902 8.296V18.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 48H11c-1.654 0-3-1.413-3-3.15v-23.1c0-1.738 1.346-3.15 3-3.15h26c1.654 0 3 1.412 3 3.15v23.1c0 1.737-1.346 3.15-3 3.15Zm-25-4.2h24v-21H12v21Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.896 38.55h-3.792c-.578 0-1.018-.545-.923-1.144L22 32.25l-.272-1.144c-.37-1.553.748-3.057 2.272-3.057 1.524 0 2.642 1.504 2.272 3.056L26 32.25l.819 5.156c.095.599-.345 1.144-.923 1.144Z"
  })));
};
export default SvgLock;